import m from "../../geodata/es2015/vietnamHigh";
window.am4geodata_vietnamHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/vietnamHigh.js
// module id = null
// module chunks = 